<template lang="pug">
  .layout.my-1(v-if="products.length > 0")
    v-row(no-gutters align="center")
      v-col.shrink.mr-4
        v-card.d-flex.justify-center.align-center(outlined style="border: 1px solid" :style="$vuetify.breakpoint.xs ? 'width: 56px' : 'width: 70px'" :height="$vuetify.breakpoint.xs ? '56px' : '70px'")
          v-img(:src="products[0].image ? products[0].image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
      v-col
        div.p1.basic700--text {{ productsListing }}
</template>

<script>
export default {
  name: 'BundleList',
  props: {
    products: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    productsListing() {
      if (this.products.length === 1) {
        return this.products[0].name
      } else if (this.products.length === 2) {
        return this.products.map(product => product.name).join(', ')
      } else {
        const firstTwo = this.products.slice(0, 2).map(product => product.name).join(', ') + ', '
        const remaining = `+${this.products.slice(2).length} other`
        return firstTwo + remaining
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>